import angular from 'angular'

import '../analytics-shared/analytics-shared.module'

import { analyticsService } from '../analytics/services/analytics.service'

import { createCampaignDialog } from './dialogs/create-campaign/create-campaign-dialog.directive'
import { removeAttachmentDialog } from './dialogs/remove-attachment/remove-attachment-dialog.directive'
import { campaignAccessDialog } from './dialogs/campaign-access/campaign-access-dialog.directive'
import { campaignUpdateDialog } from './dialogs/campaign-update/campaign-update-dialog.directive'
import { campaignListCard } from './directives/campaign-list-card/campaign-list-card.directive'
import { campaignBriefing } from './directives/campaign-briefing/campaign-briefing.directive'
import { campaignDocument } from './directives/campaign-document/campaign-document.directive'
import { campaignWorkflow } from './directives/campaign-workflow/campaign-workflow.directive'
import { campaignMaterials } from './directives/campaign-materials/campaign-materials.directive'
import { campaignMaterialsTemplates } from './directives/campaign-materials-templates/campaign-materials-templates.directive'
import { campaignMaterialsFolders } from './directives/campaign-materials-folders/campaign-materials-folders.directive'
import { campaignPosts } from './directives/campaign-posts/campaign-posts.directive'
import { campaignChecklist } from './directives/campaign-checklist/campaign-checklist.directive'
import { CampaignEditController } from './pages/campaign-edit/campaign-edit.controller'
import { campaignAttachments } from './directives/campaign-attachments/campaign-attachments.directive'
import { campaignActions } from './directives/campaign-actions/campaign-actions.directive'
import { campaignDashboard } from './directives/campaign-dashboard/campaign-dashboard.directive'
import { campaignMaterialActions } from './directives/campaign-material-actions/campaign-material-actions.directive'
import { campaignMaterialActionsAssetCard } from './directives/campaign-material-actions-asset-card/campaign-material-actions-asset-card.directive'
import { campaignMaterialFloatingToolBar } from './directives/campaign-material-floating-tool-bar/campaign-material-floating-tool-bar.directive'
import { campaignActionsList } from './directives/campaign-actions-list/campaign-actions-list.directive'
import { campaignActionItem } from './directives/campaign-action-item/campaign-action-item.directive'
import { campaignPostActions } from './directives/campaign-post-actions/campaign-post-actions.directive'
import { campaignFloatingToolBarPosts } from './directives/campaign-floating-tool-bar-posts/campaign-floating-tool-bar-posts.directive'
import { campaignActionPostItem } from './directives/campaign-action-post-item/campaign-action-post-item.directive'
import { campaignChecklistActions } from './directives/campaign-checklist-actions/campaign-checklist-actions.directive'
import { campaignFloatingToolBarChecklists } from './directives/campaign-floating-tool-bar-checklists/campaign-floating-tool-bar-checklists.directive'
import { campaignActionChecklistItem } from './directives/campaign-action-checklist-item/campaign-action-checklist-item.directive'
import { campaignAccess } from './directives/campaign-access/campaign-access.directive'
import { campaignHeaderToolbar } from './directives/campaign-header-toolbar/campaign-header-toolbar.directive'

const module = angular
  .module('deskfy.campaigns', [
    'deskfy.analyticsShared'
  ])
  .factory('AnalyticsService', analyticsService)
  .controller('CampaignEditController', CampaignEditController)
  .directive('createCampaignDialog', createCampaignDialog)
  .directive('removeAttachmentDialog', removeAttachmentDialog)
  .directive('campaignAccessDialog', campaignAccessDialog)
  .directive('campaignListCard', campaignListCard)
  .directive('campaignBriefing', campaignBriefing)
  .directive('campaignDocument', campaignDocument)
  .directive('campaignWorkflow', campaignWorkflow)
  .directive('campaignChecklist', campaignChecklist)
  .directive('campaignPosts', campaignPosts)
  .directive('campaignMaterials', campaignMaterials)
  .directive('campaignMaterialsTemplates', campaignMaterialsTemplates)
  .directive('campaignMaterialsFolders', campaignMaterialsFolders)
  .directive('campaignAttachments', campaignAttachments)
  .directive('campaignActions', campaignActions)
  .directive('campaignDashboard', campaignDashboard)
  .directive('campaignMaterialActions', campaignMaterialActions)
  .directive('campaignMaterialActionsAssetCard', campaignMaterialActionsAssetCard)
  .directive('campaignMaterialFloatingToolBar', campaignMaterialFloatingToolBar)
  .directive('campaignActionsList', campaignActionsList)
  .directive('campaignActionItem', campaignActionItem)
  .directive('campaignPostActions', campaignPostActions)
  .directive('campaignFloatingToolBarPosts', campaignFloatingToolBarPosts)
  .directive('campaignActionPostItem', campaignActionPostItem)
  .directive('campaignChecklistActions', campaignChecklistActions)
  .directive('campaignFloatingToolBarChecklists', campaignFloatingToolBarChecklists)
  .directive('campaignActionChecklistItem', campaignActionChecklistItem)
  .directive('campaignAccess', campaignAccess)
  .directive('campaignHeaderToolbar', campaignHeaderToolbar)
  .directive('campaignUpdateDialog', campaignUpdateDialog)

export const campaignsModule = module
